import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { updateLatelyCardTemplate } from '../redux/latelyCardTemplateDbSlice';
import useCurrentUserId from './useCurrentUserId';
import { makeLately } from '../general';
import { TemplateValueType } from '../components/AddCardDialog';

const useLatelyCardTemplates = (): [string[], TemplateValueType[], string] => {
  const dispatch = useDispatch();
  const userId = useCurrentUserId();
  const latelyCardTemplateDb = useSelector((state: RootState) => state.latelyCardTemplateDb);
  const cardTemplateDb = useSelector((state: RootState) => state.cardTemplateDb);
  const latelyCardTemplateId = Object.keys(latelyCardTemplateDb.latelyCardTemplates).filter(id => latelyCardTemplateDb.latelyCardTemplates[id].userId === userId)[0];

  let ids = latelyCardTemplateDb.latelyCardTemplates[latelyCardTemplateId]?.cardTemplateIds;
  const values: TemplateValueType[] = [];
  let ix = 0;
  const deletedIds: string[] = [];

  if (!ids) return [[], [], latelyCardTemplateId];

  ids.forEach(id => {
    if (Boolean(cardTemplateDb.cardTemplates[id])) {
      values.push({ ...cardTemplateDb.cardTemplates[id], order: ix });
      ix++;
    }
    else deletedIds.push(id);
  })

  if (deletedIds.length >= 1) {
    deletedIds.forEach(id => ids = makeLately(ids, id, 'delete'))
    dispatch(updateLatelyCardTemplate({ id: latelyCardTemplateId, cardTemplateIds: ids }));
  }

  return [ids, values, latelyCardTemplateId];
}

export default useLatelyCardTemplates;
